define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'es6!launcher/actions/SubscribersActions',
], (Util, Immutable, _, Actions) => {
  const initialState = Immutable.Map({
    // hasLoaded is set when we load settings. We need it so we don't do
    // certain things without having the correct settings. For instance, if the
    // user is pro but the settings load after the popup, the popup will fail
    // validating and the default popup will be shown.
    hasLoaded: false,
    reqId: null,
    hash: null,
    notice: Immutable.Map(),
    senderName: '',
    senderAddress: '',
    pushIconUrl: null,
    sumoMailDomain: { valid: false, sumoMailSendgridSubuser: null },
    tosAccepted: true,
    countries: Immutable.List(),
    states: Immutable.List(),
    sources: Immutable.List(),
    freezeWarning: false,
    lastContactedAtByEmail: false,
    lastContactedAtByPush: false,
    name: '',
    page: 1,
    state: [
      'queued',
      'sending',
      'sent',
    ],

    footerGroupName: 'Sumo Group, Inc.',
    footerAddress: '1305 E. 6th St. #3, Austin, TX 78702',
    footerBgColor: '#023A5B',
    footerTextColor: '#85B9DD',
    headerImage: null,
    footerAltText: null,
    defaultEmailTemplate: null,
  });

  const actionHandlers = {};

  const cleanSettings = (state, settings) => (
    Object.keys(settings).reduce((memo, key) => {
      if (!settings[key] && key !== 'tosAccepted') return memo;
      return Object.assign({}, memo, { [key]: settings[key] });
    }, {})
  );

  actionHandlers[Actions.RECEIVE_SETTINGS] = (state, action) => {
    const settings = action.settings || {};
    const nextSettings = Object.assign({}, cleanSettings(state, settings), { hasLoaded: true });
    return state.merge(nextSettings);
  };

  actionHandlers[Actions.UPDATE_SUBSCRIBERS_SETTING] = (state, action) => {
    const settingName = action.setting;
    const settingValue = action.value;

    if (!settingName || !settingValue) return state;
    return state.setIn([settingName], Immutable.fromJS(settingValue));
  };

  actionHandlers[Actions.UPDATE_SUBSCRIBERS_SETTINGS] = (state, action) => {
    const settings = action.settings || {};
    const nextSettings = cleanSettings(state, settings);

    return state.merge(nextSettings);
  };

  return Util.createReducer(initialState, actionHandlers);
});
